import Home from "../src/components/Home";
import CarDetails from "./components/CarDetails/CarDetails";
import CarList from "./components/CarList";
import CarBooking from "./components/CarBooking";
import Login from "./components/auth/Login";
import Signup from "./components/auth/Signup";
import OtpVerifcation from "./components/auth/OtpVerification";
import EditProfile from "./components/Profile/EditProfile";
import Summary from "./components/Summary";
import Payment from "./components/Payment";
import Favourite from "./components/Favourites";
import MyBooking from "./components/MyBooking";
import MyVehicle from "./components/MyVehicle";
import Orders from "./components/Orders";
import Notification from "./components/Notification/Notification";
import ContactUs from "./components/ContactUs";
import RentYourCar from "./components/RentYourCar";
import Dashboard from "./components/Dashboard";
import AboutUs from "./components/Aboutus";
import Translator from "./components/translator";
import TermsAndConditions from "./components/TermsAndCondition";
import ForgetPassword from "./components/auth/ForgetPassword";
import ResetPassword from "./components/auth/ResetPassword";
import CompletedOrder from "./components/MyBooking/CompletedOrder";
import PaymentRedirect from "./components/Summary/PaymentRedirect";
import GpsPaymentRedirect from "./components/RentYourCar/GpsPaymentRedirect";
import UploadModal from "./components/auth/Signup/UploadDocModal";
import VefifyPayment from "./components/Summary/VerifyPayment";
import AppPayment from "./components/App Payment/AppPayment";
import AppPaymentVerify from "./components/App Payment/AppPaymentVerify";
import AppPaymentFail from "./components/App Payment/AppPaymentFail";
import GpsPaymentVerify from "./components/RentYourCar/GpsPaymentVerify";

export const route = [
  {
    id: 0,
    name: "Home",
    path: "/",
    component: <Home />,
  },
  {
    id: 1,
    name: "CarList",
    path: "/carlist",
    component: <CarList />,
  },
  {
    id: 2,
    name: "CarDetail",
    path: "/cardetail/:carId",
    component: <CarDetails />,
  },
  {
    id: 3,
    name: "CarBooking",
    path: "/carbooking",
    component: <CarBooking />,
  },
  {
    id: 4,
    name: "Login",
    path: "/login",
    component: <Login />,
  },
  {
    id: 5,
    name: "signup",
    path: "/signup",
    component: <Signup />,
  },
  {
    id: 6,
    name: "otp verification",
    path: "/otp/:route",
    component: <OtpVerifcation />,
  },
  {
    id: 7,
    name: "edit profile",
    path: "/edit-profile",
    component: <EditProfile />,
  },
  {
    id: 8,
    name: "summary",
    path: "/summary",
    component: <Summary />,
  },
  {
    id: 9,
    name: "payment",
    path: "/payment",
    component: <Payment />,
  },
  {
    id: 10,
    name: "favourite",
    path: "/favourites",
    component: <Favourite />,
  },
  {
      id: 11,
      name: "notification",
      path: "/notification",
      component: <Notification />,
  },
  {
    id: 11,
    name: "My Booking",
    path: "/mybooking",
    subroute: [
      {
        id: 11.1,
        name: "completed Order",
        path: "/mybooking/completed-order",
        component: <CompletedOrder />,
      },
      {
        id: 11.2,
        name: "recent Order",
        path: "/mybooking/recent-order",
        component: <CompletedOrder />,
      },
      {
        id: 11.3,
        name: "cancelled Order",
        path: "/mybooking/cancelled-order",
        component: <CompletedOrder />,
      },
    ],
    component: <MyBooking />,
  },
  {
    id: 12,
    name: "My Vehicle",
    path: "/myvehicle",
    component: <MyVehicle />,
  },
  {
    id: 13,
    name: "Orders",
    path: "/orders",
    component: <Orders />,
  },
  {
    id: 14,
    name: "Contact Us",
    path: "/contactUs",
    component: <ContactUs />,
  },
  {
    id: 15,
    name: "Car rental form",
    path: "/rentyourcar",
    component: <RentYourCar />,
  },
  {
    id: 16,
    name: "Dashboard",
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    id: 17,
    name: "About us",
    path: "/aboutus",
    component: <AboutUs />,
  },
  // {
  //     id: 19,
  //     name: "Languages",
  //     path: "/languages",
  //     component: <Languages />,
  // },
  {
    id: 18,
    name: "Terms and Conditions",
    path: "/termsandcondition",
    component: <TermsAndConditions />,
  },
  {
    id: 19,
    name: "Forget Password",
    path: "/forgetpassword",
    component: <ForgetPassword />,
  },
  {
    id: 20,
    name: "Reset Password",
    path: "/resetpassword",
    component: <ResetPassword />,
  },
  {
    id: 21,
    name: "Payment Redirect",
    path: "/paymentredirect",
    component: <PaymentRedirect />,
  },
  {
    id: 23,
    name: "Get Payment",
    path: "/app-payment",
    component: <AppPayment />,
  },
  {
    id: 24,
    name: "Get Payment",
    path: "/app-payment/pending",
    component: <AppPaymentVerify />,
  },
  {
    id: 25,
    name: "Get Payment",
    path: "/app-payment/failed",
    component: <AppPaymentFail />,
  },
  {
    id: 26,
    name: "Verify Payment",
    path: "/verify_payment/:reference",
    component: <VefifyPayment/>,
  },
  {
    id: 27,
    name: "Verify Payment",
    path: "/rentyourcar/verify_payment/:reference",
    component: <GpsPaymentVerify/>,
  },
  {
    id: 22,
    name: "GPS Redirect",
    path: "/gpspayment",
    component: <GpsPaymentRedirect />,
  },
  // {
  //   id: 23,
  //   name: "Upload",
  //   path: "/uploads",
  //   component: <UploadModal />,
  // },
  // {
  //     id: 23,
  //     name: "Languages",
  //     path: "/languages",
  //     component: <Translator />,
  // },
];
